import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap"
import { OrganisationAddEdit } from "./common/formsCreateEdit/organisationAddEdit";
import { useNavigate } from "react-router-dom";
import Loading from './common/loading';
import SuccessModal from "./common/successModal";
import useApi from '../utilities/useApi';
import roleUtilities from '../utilities/roleUtilities';
export default function AddOrganisation ({organisationalUnits, user}) {
    const { api } = useApi();
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [parentId, setParentId] = useState(user?.organisationalUnitId ?? "");
    const [disabled, setDisabled] = useState(false);
    const [createShard, setCreateShard] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [success, setSuccess] = useState(null)

    const onSave = () => {
        setIsLoading(true);
        api.createOrganisationalUnit(
            parentId,
            name,
            disabled,
            createShard,
            data => {
                if (data?.id) {
                    navigate("/organisations")
                } else {
                    setIsLoading(false)
                    setSuccess({ message: "Your organisation is being created. You will receive an email when it's complete." })
                }
            },
            error => {
                console.log(error)
                setIsLoading(false)
            }
        )
    }

    return (
        <Container className='pt-5 pb-lg-4 mt-5 mb-sm-2'>
            <Row>
                <Col className='mb-5'>
                    <div className='d-flex justify-content-between my-5'>
                        <h1 className="h2 m-0">Add Organisation</h1>
                    </div>
                    <div>
                        {
                            isLoading
                            ? <Loading />
                            : <OrganisationAddEdit
                                isAdd
                                name={name}
                                setName={setName}
                                parentId={parentId}
                                setParentId={setParentId}
                                organisationalUnits={organisationalUnits}
                                disabled={disabled}
                                setDisabled={setDisabled}
                                createShard={createShard}
                                setCreateShard={setCreateShard}
                                isGlobalAdmin={user && roleUtilities.isGlobalAdmin(user)}
                                handleCancel={() => navigate("/organisations")}
                                handleSubmit={() => onSave()}
                            />
                        }
                    </div>
                </Col>
            </Row>
            {success && <SuccessModal success={success} onDismiss={() => navigate("/organisations")} />}
        </Container>
    )
}
